export default __webpack_public_path__ + "static/noihonourablemention2019-8a551635a794536b7479aec16ef7223f.jpg";